/**
 * Autogenerated file don't modify
 */
(function () {
(function (swiper) {
    'use strict';

    MoyaComponents.register('banner.carousel', function (el) {
        MoyaLoader.all([
            'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css',
            'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js',
        ]).then(function () {
            new swiper.Swiper('.' + el.className + ' .swiper-container', {
                createElements: true,
                slidesPerView: 1,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        });
    });

}(window));
typeof tsBuild === 'function' && tsBuild();})();
